/* eslint-disable no-unused-vars */

// Aggiungi una classe
const addClass = (el, className) => {
  if (el && !el.classList.contains(className)) {
    el.classList.add(className);
  }
};

// Rimuovi una classe
const removeClass = (el, className) => {
  if (el && el.classList.contains(className)) {
    el.classList.remove(className);
  }
};

// Toggle di una classe
const toggleClass = (el, className) => {
  if (el && el.classList.contains(className)) {
    el.classList.remove(className);
  } else {
    el.classList.add(className);
  }
};
